import styled from 'styled-components'


export const ModalAlertDiv = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 0;
  align-items: center;
  flex-direction: column;
  text-align: center;

  a {
    text-decoration: none;
    color: #fff;
  }
`;
